import { PayloadAction } from '@reduxjs/toolkit';
import { EntityTypes } from 'constants/entities';
import { updateState } from 'core/actions/product/state';
import { ICopyItem } from 'core/slices/commands';
import { createSlice } from 'utils/@reduxjs/toolkit';

export enum FlowPage {
  MOD_FLOW = 0,
  ACTION = 1,
  SCENE = 2,
  COURSE = 3,
  GROUP = 4,
  MOD_LIST = 5,
  MOD_CAROUSEL = 6,
  COURSE_CONTENT = 7,
  COURSE_LEARNERS = 8,
}

export interface ISelectNode extends ICopyItem {
  data: any;
}

export interface IFlowState {
  viewport: IViewPort;
  selectedNode: ISelectNode;
  prevNode: ISelectNode;
  page: FlowPage;
  extension: EntityTypes;
  moveComplete: boolean;
  dragging: boolean;
}

export interface IViewPort {
  x: number;
  y: number;
  zoom: number;
  manual?: boolean;
}

export const initialState: IFlowState = {
  viewport: {
    x: 0,
    y: 0,
    zoom: 1,
  },
  selectedNode: null,
  prevNode: null,
  page: null,
  extension: null,
  moveComplete: false,
  dragging: false,
};

const slice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    moveView(state, action: PayloadAction<IViewPort>) {
      state.viewport = action.payload;
      state.moveComplete = true;

      if (action.payload.manual) state.selectedNode = null;
    },
    selectModNode(state, action: PayloadAction<ISelectNode>) {
      state.prevNode = state.selectedNode;
      state.selectedNode = action.payload;
      state.moveComplete = false;
      state.extension = null;
      state.dragging = false;
    },
    updateFlowPage(state, action: PayloadAction<FlowPage>) {
      state.page = action.payload;
      //This stops preview from node working
      //state.selectedNode = null;
      state.dragging = false;
      state.prevNode = null;
    },
    updateExtension(state, action: PayloadAction<EntityTypes>) {
      state.extension = action.payload;
    },
    updateDragging(state, action: PayloadAction<boolean>) {
      state.dragging = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase('commands/select', (state, action: any) => {
      if (!action.payload.nodes.length) {
        //state.prevNode = null;
        state.selectedNode = null;
      }
    });
    //Need this to edit actions in preview module
    builder.addCase(updateState, (state, action: any) => {
      if (action.payload.type === EntityTypes.ACTION) state.selectedNode = null;
    });
  },
});

export const { actions: flowActions, reducer } = slice;

export default reducer;
